import Helper from '../helpers/Helper';
import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

export default class ScrollAnchor {
    static init() {
        this.setDefaultArgs();
        this.bindActiveStates();
        this.bindLinks();
        this.initialJump();
    }

    static setDefaultArgs() {
        this.scrollContainer = Helper.isInsideEditor() ? '.page-wrap' : null;
        this.scrollOffset = '.page-header';
        this.targetAttribute = 'data-id';
        this.activeClass = 'mainmenu__link--anchor-active';
    }

    static bindActiveStates() {
        this.setDefaultArgs();
        this.resetActiveStates();
        this.updateActiveStates();
        this.getContainer().addEventListener('scroll', () => {
            this.updateActiveStates();
        });
    }
    static resetActiveStates() {
        this.setDefaultArgs();
        if (document.querySelector('.' + this.activeClass) !== null) {
            document.querySelectorAll('.' + this.activeClass).forEach((el) => {
                el.classList.remove(this.activeClass);
            });
        }
    }
    static updateActiveStates() {
        this.setDefaultArgs();
        if (document.querySelector('[' + this.targetAttribute + ']') !== null) {
            let done = false;
            document.querySelectorAll('[' + this.targetAttribute + ']').forEach((el) => {
                if (done === true) {
                    return;
                }
                let offset = this.offsetTop(el),
                    origin = document.querySelector(
                        '[href*="' + el.getAttribute(this.targetAttribute) + '"]'
                    );
                if (
                    offset >= this.scrollTop() &&
                    offset <= this.scrollTop() + this.windowHeight() &&
                    origin !== null
                ) {
                    if (document.querySelector('.' + this.activeClass) !== null) {
                        document.querySelectorAll('.' + this.activeClass).forEach((el2) => {
                            if (origin !== el2) {
                                el2.classList.remove(this.activeClass);
                            }
                        });
                    }
                    origin.classList.add(this.activeClass);
                    done = true;
                }
            });
        }
    }
    static bindLinks() {
        document.documentElement.addEventListener('click', (e) => {
            let el = e.target.closest('[href*="#"]');
            if (el) {
                let href = el.getAttribute('href');
                if (this.isLinkInternal(href)) {
                    let id = this.extractIdFromLink(href);
                    if (
                        document.querySelector('[' + this.targetAttribute + '="' + id + '"]') !==
                        null
                    ) {
                        this.scrollTo(id);
                        e.preventDefault();
                    } else {
                        // use local storage to save target (we do not want ugly hashes)
                        localStorage.setItem('initialJump', id);
                        el.setAttribute('href', href.substring(0, href.indexOf('#')));
                    }
                }
            }
        });
    }
    static initialJump() {
        if (localStorage.getItem('initialJump') !== null) {
            requestAnimationFrame(() => {
                this.scrollTo(localStorage.getItem('initialJump'));
                localStorage.removeItem('initialJump');
            });
        } else if (window.location.hash) {
            let hash = window.location.hash.replace('#', '');
            this.removeHashFromUrl();
            requestAnimationFrame(() => {
                this.scrollTo(hash);
            });
        }
    }
    static scrollTo(id) {
        if (id === 'top') {
            this.scrollToTop();
            return;
        }
        this.setDefaultArgs();
        let target = document.querySelector('[' + this.targetAttribute + '="' + id + '"]');
        if (target === null) {
            return;
        }
        let top = this.offsetTop(target);
        let container = this.getContainer();

        let leeway = 100;
        if (
            this.scrollOffset !== null &&
            document.querySelector(this.scrollOffset) !== null &&
            document.querySelector(this.scrollOffset).offsetHeight > leeway
        ) {
            leeway = document.querySelector(this.scrollOffset).offsetHeight;
        }
        top -= leeway;

        container.scroll({ top: top, left: 0, behavior: 'smooth' });
    }
    static scrollToTop() {
        let container = this.getContainer();
        container.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }
    static getContainer() {
        if (this.scrollContainer !== null && this.scrollContainer != window) {
            return document.querySelector(this.scrollContainer);
        }
        return window;
    }
    static windowHeight() {
        if (this.scrollContainer !== null) {
            return this.getContainer().offsetHeight;
        } else {
            return window.innerHeight;
        }
    }
    static offsetTop(el) {
        let val;
        if (this.scrollContainer !== null) {
            // offset of element inside container
            val =
                el.getBoundingClientRect().top +
                this.getContainer().scrollTop -
                document.documentElement.clientTop;
            // offset of container
            val -=
                this.getContainer().getBoundingClientRect().top +
                window.pageYOffset -
                document.documentElement.clientTop;
        } else {
            val =
                el.getBoundingClientRect().top +
                window.pageYOffset -
                document.documentElement.clientTop;
        }
        return val;
    }
    static scrollTop() {
        if (this.scrollContainer !== null) {
            return this.getContainer().scrollTop;
        } else {
            return (
                (document.documentElement && document.documentElement.scrollTop) ||
                document.body.scrollTop
            );
        }
    }
    static isLinkInternal(href) {
        if (href.indexOf(window.location.protocol + '//' + window.location.host) > -1) {
            return true;
        }
        if (href.indexOf('http') !== 0) {
            return true;
        }
        return false;
    }
    static extractIdFromLink(href) {
        return href.substring(href.indexOf('#') + 1);
    }
    static extractPageFromLink(href) {
        return href.substring(0, href.indexOf('#'));
    }
    static removeHashFromUrl() {
        if (history.pushState) {
            window.history.replaceState(
                {},
                '',
                window.location.protocol +
                    '//' +
                    window.location.hostname +
                    window.location.pathname
            );
        }
    }
}
